/**
 * Builds REACT_APP_INTERIM_PDF URL with JWT for the PDF service (new tab / window.open).
 */
export const getInterimPdfUrl = (params) => {
  const base = process.env.REACT_APP_INTERIM_PDF;
  const token =
    typeof localStorage !== "undefined"
      ? localStorage.getItem("xsrfToken")
      : "";
  const q = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v !== undefined && v !== null) q.set(k, String(v));
  });
  if (token) q.set("token", token);
  return `${base}?${q.toString()}`;
};
